var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpHeaders as Headers } from '@angular/common/http';
import { SocketService } from './socket.service';
import { UserService } from './user.service';
import { CommonRequestService } from './common-request.service';
import { AppSettings } from './../app.settings';
import { AuthTokenService } from './auth-token.service';
import { ClearService } from './clear.service';
var AuthService = /** @class */ (function () {
    function AuthService(
    // private stateService: StateService,
    jwtHelper, clearService, socketService, tokenService, userService, requestService) {
        this.jwtHelper = jwtHelper;
        this.clearService = clearService;
        this.socketService = socketService;
        this.tokenService = tokenService;
        this.userService = userService;
        this.requestService = requestService;
    }
    AuthService.prototype.login = function (email, password, successCallback, errorCallback) {
        var body = {
            email: email,
        };
        // TODO. curretly authentication check will pass even without a password
        if (password) {
            body.password = password;
        }
        // prevState will be set in login.component
        // const prevStateInfo = sessionStorage.getItem('prevState');
        return this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/login', body, successCallback, errorCallback, true);
    };
    // Register a new agency
    // This function should not be called alone. Call together with sendVerifyEmail
    AuthService.prototype.registerAgency = function (agencyNameShort, adminEmail, password, agencyNameLong, parentId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = {
                customerShortName: agencyNameShort,
                email: adminEmail,
                password: password
            };
            if (agencyNameLong) {
                body.customerLongName = agencyNameLong;
            }
            if (parentId) {
                body.parentId = parentId;
            }
            _this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/customer', body, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); }, true);
        });
    };
    // Send an link to the email regesitered as admin for verification
    // User will use a link in that email to activate their newly-created account
    AuthService.prototype.sendVerifyEmail = function (email, agencyName) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = {
                email: email,
                agency: agencyName,
                emailLinkRoot: AppSettings.rootLink + 'auth/verify',
                // NOTE: approveEmailLinkRoot is NOT used in AZGIV!!!!!!!
                approveEmailLinkRoot: AppSettings.portalRootLink + 'auth/register-approve'
            };
            _this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/register', body, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); }, true);
        });
    };
    // Activate user after they verify email
    AuthService.prototype.activateUser = function (token) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var info = _this.jwtHelper.decodeToken(token);
            // Update user status (activate user)
            var urlUpdate = AppSettings.serviceRootUrl + 'admin/user';
            var bodyUpdate = {
                email: info.email,
                state: 'ACTIVE'
            };
            _this.requestService.requestPut(urlUpdate, bodyUpdate, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); }, true);
        });
    };
    // Send an link to the email regesitered as admin for verification
    AuthService.prototype.registerAgencyConfirm = function (email, successCallback, errorCallback) {
        var body = {
            email: email,
            emailLinkRoot: AppSettings.rootLink + 'auth/register/verify'
        };
        this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/register', body, successCallback, errorCallback, true);
    };
    // Veriry Link and the newly registered admin set the password
    AuthService.prototype.registerVerify = function (password, token, successCallback, errorCallback) {
        var info = this.jwtHelper.decodeToken(token);
        var body = {
            email: info.usr_email,
            password: password,
            // application: AppSettings.appName,
            state: 'ACTIVE' // 1025 // TODO
        };
        var headers = new Headers({
            Authorization: 'Bearer ' + token
        });
        this.requestService.requestPut(AppSettings.serviceRootUrl + 'admin/user', body, successCallback, errorCallback, true, headers);
    };
    // Update password
    AuthService.prototype.updatePw = function (password, token, isUpdateUserState) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var info;
            try {
                info = _this.jwtHelper.decodeToken(token);
            }
            catch (err) {
                console.log('Invalid Token.');
                reject(err);
                return;
            }
            var body = {
                email: info.email,
                password: password
            };
            if (isUpdateUserState) {
                body.state = 'ACTIVE';
            }
            var headers = new Headers({
                Authorization: 'Bearer ' + token
            });
            _this.requestService.requestPut(AppSettings.serviceRootUrl + 'admin/user', body, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); }, true, headers);
        });
    };
    // Invite user: send an email to the invited user
    AuthService.prototype.inviteUser = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = {
                email: email,
                emailLinkRoot: AppSettings.portalRootLink + 'auth/set-pw'
            };
            _this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/invite', body, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); });
        });
    };
    // Sent an email to account to reset password
    AuthService.prototype.retrievePw = function (email, successCallback, errorCallback) {
        var body = {
            email: email,
            emailLinkRoot: AppSettings.rootLink + 'auth/resetpw'
        };
        return this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/reset', body, successCallback, errorCallback, true);
    };
    // Set App to update koken automatically every XX second
    AuthService.prototype.setTokenUpdateInterval = function () {
        var _this = this;
        console.log('set token update interval');
        if (this.tokenUpdateInterval) {
            clearInterval(this.tokenUpdateInterval);
        }
        this.tokenUpdateInterval = setInterval(function () {
            _this.updateToken();
        }, 560000);
    };
    AuthService.prototype.clearTokenUpdateInterval = function () {
        console.log('clear token update interval. Warning: Token Stop Updating!!!');
        if (this.tokenUpdateInterval) {
            clearInterval(this.tokenUpdateInterval);
            this.tokenUpdateInterval = null;
        }
    };
    AuthService.prototype.updateToken = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/login';
            _this.requestService.requestGet(url, null, function (rsp) { return __awaiter(_this, void 0, void 0, function () {
                var token;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = rsp.data.content;
                            return [4 /*yield*/, this.userService.setUpdatedToken(token)];
                        case 1:
                            _a.sent();
                            // this.token = token;
                            // localStorage.setItem(this.tokenService.authTokenName, token);
                            // this.userService.setUserInfoFromToken();
                            // // Update customerInfo
                            // await this.userService.getCustomerInfo(this.userService.getUserInfo().customerId, true, true);
                            resolve();
                            return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                if (err.error.error.errorDetail === 'jtw expired') {
                    _this.clearService.logout();
                }
                // console.log(this.token, this.jwtHelper.isTokenExpired(this.token));
                // console.log('isTokenExpired: ', this.isTokenExpired());
                reject(err);
            });
        });
    };
    // TO Delete
    AuthService.prototype.test = function () {
        // const headers: any = {
        // 	// 'content-length': 114,
        // 	// 'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        // 	// "enctype": "multipart/form-data",
        // 	'Accept': 'application/json;odata=verbose'
        // 	// 'content-type': 'application/Json',
        // 	// 'host': '192.168.0.129:8080'
        // };
        var headers = new Headers();
        headers.append('Accept', 'application/json');
        // headers.delete('Content-Type');
        // headers.delete('Accept');
        // headers.set('Accept', 'text/html, application/xhtml+xml, application/xml;q=0.9, */*;q=0.8');
        headers.set('Content-Type', 'application/x-www-form-urlencoded');
        headers.set('Cache-Control', 'no-cache');
        var dataRequestObj = {
            service: 'WFS',
            version: '1.0.0',
            request: 'GetFeature',
            typeName: 'emap:ADDRESSES',
            CQL_FILTER: 'ESN=\'001\'',
            outputFormat: 'CSV'
        };
        var formData = new FormData();
        formData.append('service', 'WFS');
        formData.append('version', '1.0.0');
        formData.append('request', 'GetFeature');
        formData.append('typeName', 'emap:ADDRESSES');
        formData.append('CQL_FILTER', 'ESN=\'001\'');
        formData.append('outputFormat', 'CSV');
        var bodyParams = new URLSearchParams();
        bodyParams.set('service', 'WFS');
        bodyParams.set('version', '1.0.0');
        bodyParams.set('request', 'GetFeature');
        bodyParams.set('typeName', 'emap:ADDRESSES');
        bodyParams.set('CQL_FILTER', 'ESN=\'001\'');
        bodyParams.set('outputFormat', 'CSV');
        this.requestService.requestPost('http://192.168.88.129:8081/geoserver/emap/ows', formData, function (rsp) {
            debugger;
        }, function (err) {
            debugger;
        }, true, {
            headers: headers
        });
        // request.post({ url: "http://192.168.0.129:8080/geoserver/emap/ows", form: dataRequestObj}, (err, rsp, body) => {
        // 	debugger
        // });
    };
    return AuthService;
}());
export { AuthService };
